import pythonApi from '../api/pythonApi';
import { DocumentationApiClient, DocumentationBucket } from './documentationApiClient';

const multipartConfig = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

class SensorboxGroupDocumentationService implements DocumentationApiClient {
  getDocumentation = async (groupId: string) => {
    return pythonApi.get(`/api/v1/sensorbox-groups/${groupId}/documentation`);
  };

  getRollup = async (groupId: string) => {
    return pythonApi.get(`/api/v1/sensorbox-groups/${groupId}/documentation/rollup`);
  };

  addModelEntry = async (
    groupId: string,
    params: { file: File; text?: string; createdAt?: number }
  ) => {
    const formData = new FormData();
    formData.append('file', params.file);
    if (params.text) formData.append('text', params.text);
    if (params.createdAt != null) formData.append('created_at', String(params.createdAt));
    return pythonApi.post(`/api/v1/sensorbox-groups/${groupId}/documentation/model`, formData, multipartConfig);
  };

  deleteModelEntry = async (groupId: string, entryId: string) => {
    return pythonApi.delete(`/api/v1/sensorbox-groups/${groupId}/documentation/model/${entryId}`);
  };

  addBucketFiles = async (
    groupId: string,
    bucket: DocumentationBucket,
    files: File[],
    text?: string,
    createdAt?: number
  ) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    if (text) formData.append('text', text);
    if (createdAt != null) formData.append('created_at', String(createdAt));
    return pythonApi.post(
      `/api/v1/sensorbox-groups/${groupId}/documentation/${bucket}/files`,
      formData,
      multipartConfig
    );
  };

  deleteBucketFile = async (groupId: string, bucket: DocumentationBucket, fileId: string) => {
    return pythonApi.delete(`/api/v1/sensorbox-groups/${groupId}/documentation/${bucket}/files/${fileId}`);
  };

  getBucketFileContent = async (
    groupId: string,
    bucket: DocumentationBucket,
    fileId: string,
    disposition: 'inline' | 'attachment' = 'inline'
  ) => {
    return pythonApi.get(
      `/api/v1/sensorbox-groups/${groupId}/documentation/${bucket}/files/${fileId}/content?disposition=${disposition}`,
      { responseType: 'blob' }
    );
  };

  getModelFileContent = async (
    groupId: string,
    entryId: string,
    disposition: 'inline' | 'attachment' = 'inline'
  ) => {
    return pythonApi.get(
      `/api/v1/sensorbox-groups/${groupId}/documentation/model/${entryId}/file/content?disposition=${disposition}`,
      { responseType: 'blob' }
    );
  };
}

const instance = new SensorboxGroupDocumentationService();

export default instance;